import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAuthenticationUsageService = ( createDecorator('IAuthenticationUsageService'));
export { IAuthenticationUsageService };
